/**
 * Author: Paul Grejaldo
 * Date: 2018/10/16
 * Time: 9:05 PM
 */
import React, { Component, Fragment } from 'react';
import Form from '../components/Form';
import { connect } from 'react-redux';
import { appPropChange } from '../actions';
import ZipCodeFound from '../components/ZipCodeFound';
import ZipCodeNotFound from '../components/ZipCodeNotFound';

class App extends Component {
	constructor( props ) {
		super( props );
	}

	componentDidCatch( error, info ) {
		console.log( error );
		console.log( info );
	}

	handleZipCodeChange = ( value ) => {
		this.props.appPropChange( { zipCode : value } );
	};

	handleSubmit = ( zipCode, e ) => {
		e.preventDefault();

		const { zipCodes } = serviceArea;

		this.props.appPropChange( { zipCode } );
		if ( '' !== zipCode ) {
			if ( zipCodes.includes( `${ zipCode }` ) ) {
				this.props.appPropChange( { hasService : true } );
			} else {
				this.props.appPropChange( { hasService : false } );
			}
		} else {
			this.props.appPropChange( { hasService : null } );
		}
	};

	handleKeyDown = ( value, e ) => {
		if ( e.key === 'Enter' ) {
			this.handleSubmit( value, e );
		}
	};

	render() {
		const { zipCode, hasService } = this.props;

		return (
			<Fragment>
				<Form
					onZipCodeChange={ this.handleZipCodeChange }
					onSubmit={ this.handleSubmit }
					onKeyDown={ this.handleKeyDown }
				/>
				<ZipCodeFound zipCode={ zipCode } hasService={ hasService } />
				<ZipCodeNotFound hasService={ hasService } />
			</Fragment>
		);
	}
}

export default connect(
	state => {
		return {
			...state.serviceAreaApp
		};
	},
	{
		appPropChange
	}
)( App );
